var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI icon/send/filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M6.29602 2.90554C3.91012 1.80435 1.36183 4.08519 2.19279 6.5781L3.45424 10.3192C3.59136 10.7258 3.97267 10.9997 4.40182 10.9997H13C13.5523 10.9997 14 11.4474 14 11.9997C14 12.552 13.5523 12.9997 13 12.9997H4.40182C3.97267 12.9997 3.59136 13.2735 3.45424 13.6802L2.19281 17.4213C1.36183 19.9142 3.91012 22.195 6.29603 21.0938L20.0983 14.7236C22.422 13.6511 22.422 10.3483 20.0983 9.27583L6.29602 2.90554Z",
    fill: "#DADADA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.12c8acac115c793d5b70ec748142cda0.svg";
export { ForwardRef as ReactComponent };